import React from 'react';

import ContentsSelect from './BottomSheetContentsSelect';
import styles from './BottomSheetContentsSelectIcon.module.scss';

export type SelectIconSet = [React.ReactNode, string, React.MouseEventHandler<unknown>];

interface IBottomSheetContentsSelectIconProps {
  children: readonly (SelectIconSet | null)[];
}

const BottomSheetContentsSelectIcon: React.FC<IBottomSheetContentsSelectIconProps> = ({ children }) => {
  return (
    <ContentsSelect.Container>
      {(children as readonly SelectIconSet[]).filter(Boolean).map(([icon, label, onClick]) => {
        return (
          <ContentsSelect.Cell key={label} as="button" className={styles.item} onClick={onClick}>
            <span className={styles.icon}>{icon}</span>
            <span className={styles.label}>{label}</span>
          </ContentsSelect.Cell>
        );
      })}
    </ContentsSelect.Container>
  );
};

export default BottomSheetContentsSelectIcon;
